var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.redefine-all.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.redefine-all.js
// module chunks = 0